import Grid from 'styled-components-grid';
import styled from 'styled-components';

const CardGridUnit = styled(Grid.Unit)`
  height: ${({height}) => height};
`;

export default CardGridUnit;
